/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useRef, useCallback, useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import { Link } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import {
  Container,
  Content,
  ContentForm,
  BottomForm,
  ContentBottom,
} from './styles';

import { IUser } from '../../services/auth';
import {
  postCreateTermAcceptance,
  getSellerDataById,
  latePaymentTermAcceptance,
  getUnreadNoticesBySellerId,
  markNoticeAsRead,
} from '../../services/api';

import ModalTerms from '../../components/template/ModalTerms';
import ModalLatePaymentTerms from '../../components/template/ModalLatePaymentTerms';
import { Modal, ModalContent } from '../Notifications/styles';

import LogoYellow from '../../assets/images/logo-new-yellow.svg';
import Input from '../../components/forms/Input';
import Buttom from '../../components/forms/Buttom';
import BackgroundSign from '../../components/template/BackgroundSign';
import { useToast } from '../../hooks/toast';
import getValidationErrors from '../../utils/getVaidationErrors';
import { useAuth } from '../../hooks/auth';

const MySwal = withReactContent(Swal);

const SignIn: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const { signIn, user } = useAuth();
  const [unreadNotices, setUnreadNotices] = useState<any[]>([]);
  const [isNoticeModalOpen, setIsNoticeModalOpen] = useState(false);

  // Função para fechar o modal de notificação e marcar como lida
  const handleCloseNoticeModal = useCallback(
    async (currentUser: IUser | null) => {
      const sellerId = currentUser?.seller?.id;
      if (unreadNotices.length > 0 && sellerId) {
        await Promise.all(
          unreadNotices.map(async notice => {
            try {
              await markNoticeAsRead(notice.id, sellerId);
            } catch (error) {
              console.error(
                `Erro ao marcar notificação ${notice.id} como lida:`,
                error,
              );
              // Opcional: adicionar toast de erro ou tentar novamente
            }
          }),
        );
        setUnreadNotices([]); // Limpa as notificações exibidas após marcar como lidas
      }
      setIsNoticeModalOpen(false);
    },
    [unreadNotices, markNoticeAsRead],
  );

  const handleSubmit = useCallback(
    async data => {
      try {
        setLoading(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          email: Yup.string()
            .required('Campo Obrigatório')
            .email('Email inválido'),
          password: Yup.string().required('Campo Obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });
        const loggedInUser: IUser = await signIn(data);

        addToast({
          title: 'Sucesso!',
          type: 'success',
          description: 'Login realizado com sucesso!',
        });

        if (loggedInUser.seller?.id) {
          const { data: seller } = await getSellerDataById(
            loggedInUser.seller.id,
          );
          if (loggedInUser.type === 'seller' && !seller.accepted_terms) {
            setTimeout(() => {
              MySwal.fire({
                title: '',
                showDenyButton: true,

                showConfirmButton: true,
                denyButtonText: 'Sair',
                confirmButtonText: 'Aceito os Termos',
                allowOutsideClick: false,
                html: <ModalTerms isOpen />,
                showLoaderOnConfirm: true,
                preConfirm: confirmation => {
                  const checkbox = document.getElementById(
                    'acceptCheckbox',
                  ) as HTMLInputElement | null;

                  if (checkbox && checkbox.checked) {
                    return checkbox;
                  }
                  Swal.showValidationMessage(
                    'Clique no botão acima para confirmar',
                  );
                },
              }).then(async result => {
                if (result.isConfirmed) {
                  const createdAccept = await postCreateTermAcceptance(
                    seller.id,
                  );
                  if (createdAccept) {
                    addToast({
                      title: 'Sucesso!',
                      type: 'success',
                      description: 'Os termos foram aceitos!',
                    });
                    return;
                  }
                  addToast({
                    title: 'Erro interno!',
                    type: 'error',
                    description: 'Entre em contato com o suporte',
                  });
                }
              });
            }, 1000);
          }
          if (
            loggedInUser.type === 'seller' &&
            !seller.accepted_late_payment_terms
          ) {
            setTimeout(() => {
              MySwal.fire({
                title: '',

                showConfirmButton: true,
                confirmButtonText: 'Ok',
                allowOutsideClick: false,
                html: <ModalLatePaymentTerms isOpen />,
                showLoaderOnConfirm: true,
                preConfirm: confirmation => {
                  const checkbox = document.getElementById(
                    'acceptCheckbox',
                  ) as HTMLInputElement | null;

                  if (checkbox && checkbox.checked) {
                    return checkbox;
                  }
                  Swal.showValidationMessage(
                    'Clique no botão acima para confirmar',
                  );
                },
              }).then(async result => {
                if (result.isConfirmed) {
                  const createdAccept = await latePaymentTermAcceptance(
                    seller.id,
                  );
                  if (createdAccept) {
                    addToast({
                      title: 'Sucesso!',
                      type: 'success',
                      description: 'Os termos foram aceitos!',
                    });
                    return;
                  }
                  addToast({
                    title: 'Erro interno!',
                    type: 'error',
                    description: 'Entre em contato com o suporte',
                  });
                }
              });
            }, 1000);
          }

          // Buscar e exibir notificações não lidas
          try {
            const { data: notices } = await getUnreadNoticesBySellerId(
              loggedInUser.seller.id,
            );
            if (notices && notices.length > 0) {
              console.log('notices', notices);

              // setUnreadNotices(notices);
              // setIsNoticeModalOpen(true);

              MySwal.fire({
                title: 'Notificações Importantes',
                showConfirmButton: true,
                confirmButtonText: 'Fechar',
                allowOutsideClick: false,
                width: '600px',
                html: (
                  <div>
                    {notices.map(notice => (
                      <div
                        key={notice.id}
                        style={{
                          marginBottom: '20px',
                          borderBottom: '1px solid #eee',
                          paddingBottom: '10px',
                          textAlign: 'left',
                        }}
                      >
                        <h3>{notice.template.title}</h3>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: notice.template.htmlContent,
                          }}
                        />
                      </div>
                    ))}
                  </div>
                ),
              }).then(async () => {
                try {
                  await Promise.all(
                    notices.map(n =>
                      markNoticeAsRead(n.id, loggedInUser?.seller?.id || ''),
                    ),
                  );
                } catch (err) {
                  console.error('Erro ao marcar notificações como lidas:', err);
                }
              });
            }
          } catch (noticeError) {
            console.error(
              'Erro ao buscar notificações não lidas:',
              noticeError,
            );
            // Opcional: adicionar toast de erro para o usuário
          }
        }
        // console.log(user);
        // ----- structure for notice
        // setTimeout(() => {
        //   MySwal.fire({
        //     title: '',
        //     html: (
        //       <div>
        //         <h2 style={{ backgroundColor: '#f6c866' }}>
        //           COMUNICADO IMPORTANTE
        //         </h2>
        //         <br />
        //         <div style={{ textAlign: 'justify' }}>
        //           Prezados(as),
        //           <br />
        //           <br />        //
        //           <p>
        //             msg
        //           </p>        //
        //           <br />
        //         </div>
        //         <p>Qualquer dúvida, estamos à disposição.</p>
        //         <br />
        //         <img src={LogoYellow} alt="Logo" width={164} />
        //       </div>
        //     ),
        //   });
        // }, 1400);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
          return;
        }
        addToast({
          title: 'Opss ..',
          type: 'error',
          description:
            'Ocorreu um erro ao fazer login, verifique suas credencias.',
        });
      } finally {
        setLoading(false);
      }
    },
    [signIn, addToast],
  );

  return (
    <Container>
      <BackgroundSign />
      <Content className="slideDown">
        <ContentForm>
          <h1>Bem-vindo novamente!</h1>
          <Form onSubmit={handleSubmit} ref={formRef}>
            <Input
              name="email"
              label="Seu Email:"
              type="text"
              placeholder="email@dominio.com.br"
            />

            <Input
              name="password"
              label="Sua Senha:"
              type="password"
              placeholder="*************"
            />

            <BottomForm>
              <Link to="/forgot-password">Esqueci a senha</Link>
              <Buttom isLoading={loading} label="Entrar" />
            </BottomForm>
          </Form>
        </ContentForm>
        {/* <ContentBottom>
          Não tem uma conta? {'  '}
          <Link to="/signup/seller">Cadastre-se</Link>
        </ContentBottom> */}
      </Content>

      {isNoticeModalOpen && (
        <Modal>
          <ModalContent>
            <header>
              <h2>Notificações Importantes</h2>
              {/* <button
                type="button"
                onClick={() => handleCloseNoticeModal(user)}
              >
                ×
              </button> */}
            </header>
            {unreadNotices.map(notice => (
              <div
                key={notice.id}
                style={{
                  marginBottom: '20px',
                  borderBottom: '1px solid #eee',
                  paddingBottom: '10px',
                }}
              >
                <h3>{notice.template.title}</h3>
                <div
                  dangerouslySetInnerHTML={{
                    __html: notice.template.htmlContent,
                  }}
                />
              </div>
            ))}
          </ModalContent>
        </Modal>
      )}
    </Container>
  );
};

export default SignIn;
